<template>
  <div>
    <!-- Alerta registro no encontrado -->
    <b-alert
      variant="danger"
      :show="userData === undefined"
    >
      <h4 class="alert-heading">
        No se encontró la información.
      </h4>
      <div class="alert-body">
        Usuario no encontrado. Selecciona otro usuario
        <b-link
          class="alert-link"
          :to="{ name: 'apps-users-list'}"
        >
          de la lista.
        </b-link>
      </div>
    </b-alert>

    <template v-if="userData">
      <!-- informacion general -->
      <b-row>
        <b-col
          lg="8"
          md="12"
          sm="12"
        >
          <detalle-usuario-persona :user-data="userData" />
        </b-col>
        <!-- cuentas -->
        <b-col
          lg="4"
          md="12"
          sm="12"
        >
          <detalle-usuario-cuentas :user-data="userData" />
          <detalle-usuario-grupo :user-data="userData" />
          <detalle-usuario-rol :user-data="userData" />
        </b-col>
        <!-- grupos usuarios -->
      </b-row>
    </template>

  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BRow, BCol, BAlert, BLink,
} from 'bootstrap-vue'
import DetalleUsuarioPersona from './components/detalle-usuario/DetalleUsuarioPersona.vue'
import DetalleUsuarioGrupo from './components/detalle-usuario/DetalleUsuarioGrupos.vue'
import DetalleUsuarioRol from './components/detalle-usuario/DetalleUsuarioRoles.vue'
import DetalleUsuarioCuentas from './components/detalle-usuario/DetalleUsuarioCuentas.vue'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    // Local Components
    DetalleUsuarioPersona,
    DetalleUsuarioGrupo,
    DetalleUsuarioCuentas,
    DetalleUsuarioRol,

  },
  setup() {
    const userData = ref(null)

    const USER_APP_STORE_MODULE_NAME = 'app-user'

    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    store.dispatch('usuario/fetchUser', { d: router.currentRoute.params.id })
      .then(response => {
        userData.value = response
      })
      .catch(() => {
        userData.value = undefined
      })
    return {
      userData,
    }
  },
}
</script>
